//import React from 'react';
// 3) HELMET - Add this import to each page
import React, { Fragment,useRef, useEffect, useState } from 'react';
//import Getdata from './components/Getdata';
import { Getdata } from '../components/Getdata';
//import Portdata from '../components/PortfolioWeb';
import heroimg_portfolio from '../images/heros/portfolio.webp'; // Tell webpack this JS file uses this image
import { Helmet, HelmetProvider } from 'react-helmet-async';
import { gsap } from 'gsap';
import { useGSAP } from "@gsap/react";
import { DrawSVGPlugin } from '../js/DrawSVGPlugin.js'; // Import the JavaScript file
import ScrollTrigger from 'gsap/ScrollTrigger';


//import background_image_button from '../images/icons/icon-solid-chevron-left.svg'; // Tell webpack this JS file uses this image




const Portfolio = () => {

  const bgfx_ref_4 = useRef();

  useGSAP(() => {

   gsap.registerPlugin(DrawSVGPlugin); 
   // scroll to the top of page onload
  //window.scrollTo(0, 0);
  gsap.registerPlugin(ScrollTrigger);

   // Presets
  gsap.set(".portfolio-transition-curtain", {left:"-4000", top:"-4000"});




// ===========================
// THUMBNAIL REVEAL SCRIPT
// ===========================

function ThumbScrollFX() {

  // 1. Force hidden initial states
  gsap.set(".thumbnail-frame", { opacity: 0, rotationY: 20, rotationX: -30, perspective: 400 });
  gsap.set(".thumbnail-heading", { opacity: 0 });
  
  let thumb = document.querySelectorAll('.thumbnail');  
  
  // DESIGN FILTER BOX
  let tl_filters = gsap.timeline();
  tl_filters.to(".portfolio-filter", { duration: 1, opacity: 1, transformOrigin: "center center" }); 

  // 2. REPLACED: Use ScrollTrigger.batch for real staggering on scroll
  ScrollTrigger.batch(thumb, {
    start: 'top 85%',
    once: true,
    onEnter: (batch) => {
      // Extract all frames and headings for the cards currently entering the viewport together
      const frames = batch.map(section => section.querySelector('.thumbnail-frame'));
      const headings = batch.map(section => section.querySelector('.thumbnail-heading'));

      let tl_folder = gsap.timeline();

      // NOW stagger works because 'frames' is an ARRAY of all visible cards!
      tl_folder.to(frames, {
        duration: 1.2, 
        opacity: 1, 
        rotationY: 0, 
        rotationX: 0, 
        transformOrigin: "center center",  
        ease: "power2.out",
        stagger: 0.15 // <--- Staggers items 0.15s apart as a group
      })
      .to(headings, { 
        duration: 0.5, 
        opacity: 1,
        stagger: 0.15 
      }, "<+=0.2"); // Starts heading fade slightly after frame starts
    }
  });

  // 3. FORCE GSAP TO RE-CALCULATE SCROLL POSITIONS
  setTimeout(() => {
    ScrollTrigger.refresh();
  }, 100);
  
} // EOF - thumbScrollFX() 

ThumbScrollFX();





// Hero Animation
// ======================================================

gsap.set("#circuit_paths ellipse", { opacity: 1, scale:0.25 });

let boxes = gsap.utils.toArray("#circuit_paths ellipse");



// random lights
boxes.forEach((box, i) => {
  gsap.to(box, {
    scale:4,
    transformOrigin: "center center",
    opacity: 0,
    duration: 2,
    delay: Math.random() * 2, 
    ease: "power2.out",
  repeat:-1,
  //yoyo:true
  });
});

// animated paths.
gsap.set("#cpath_main, #cpath_1, #cpath_2, #cpath_3", {
  strokeDasharray: "0, 80", // 0 dash length, 10px gap
  strokeLinecap: "round" // Gives the dots a rounded look
});

gsap.to("#cpath_main", {
  strokeDashoffset: 80, // Move the pattern
  duration: 1,
  repeat: -1,
  ease: "linear"
});
gsap.to("#cpath_1", {
  strokeDashoffset: 80, // Move the pattern
  duration: 1,
  repeat: -1,
  ease: "linear"
});		
 gsap.to("#cpath_2", {
  strokeDashoffset: 80, // Move the pattern
  duration: 1,
  repeat: -1,
  ease: "linear"
});
 gsap.to("#cpath_3", {
  strokeDashoffset: 80, // Move the pattern
  duration: 1,
  repeat: -1,
  ease: "linear"
});
	



// THUMBNAIL Rollover - ANIMATION
// -------------------------------------------------- //

/*
// presets
gsap.set(".border-fx-top, .border-fx-bottom", { width:'0px' });
gsap.set(".border-fx-left, .border-fx-right", { height:'0px' });


// Create a timeline
let tl_thumb_fx = gsap.timeline({
	delay: 0.5,
	paused: true, 
});
tl_thumb_fx.to(".border-fx-top", { width: "100%", duration: 0.25 })
.to(".border-fx-right", { height: "100%", duration: 0.25 })
.to(".border-fx-bottom", { width: "100%", duration: 0.25 })
.to(".border-fx-left", { height: "100%", duration: 0.25 });


const thumbnails = document.querySelectorAll('.thumbnail img');

thumbnails.forEach(thumb => {
  thumb.addEventListener('mouseenter', () => {
     tl_thumb_fx.play();
  });
  thumb.addEventListener('mouseleave', () => {
   tl_thumb_fx.reverse();
  });
});
*/






    // End of useGSAP()

// ===================================== //
// JSON FILTERING
// ===================================== //









  

  }, { scope: bgfx_ref_4 });

   
  

  

  return (

  
<main className="page-content page-id_portfolio" data-page-id="portfolio" ref={bgfx_ref_4}>

<HelmetProvider>
<Fragment> 
      <Helmet>
        <title>Portfolio Designs by Mark Hawkins</title>
        <meta name="description" content="Official portfolio of Mark Hawkins: Custom web development, digital art, and bespoke graphic design tailored to elevate your brand."/>
      </Helmet>
    </Fragment>
</HelmetProvider>  

<svg version="1.1" className="portfolio-transition-curtain transition-curtain" x="0px" y="0px"viewBox="0 0 191 191" xmlSpace="preserve">
<path className="st0" d="M95.5,190.5c-52.4,0-95-42.6-95-95s42.6-95,95-95s95,42.6,95,95S147.9,190.5,95.5,190.5z"/>
<path className="st1" d="M95.5,1C147.6,1,190,43.4,190,95.5S147.6,190,95.5,190S1,147.6,1,95.5S43.4,1,95.5,1 M95.5,0
	C42.8,0,0,42.8,0,95.5S42.8,191,95.5,191S191,148.2,191,95.5S148.2,0,95.5,0L95.5,0z"/>
</svg>


<div className="hero-container-wrap"> 
<div className='hero-container'>
  <div className="hero-mask">

  <div className='mask-svg'>
    <svg viewBox="0 0 0 0" height="0" width="0">
      <defs> 
          <clipPath id="clipping" clipPathUnits="objectBoundingBox" transform="scale(0.00099, 0.00105)"> 
              <path id="dotmask" d="M853,0c0,357.9-290.1,648-648,648c-71.6,0-140.6-11.6-205-33.1v158.6C65.4,790.8,134.1,800,205,800
			c441.8,0,800-358.2,800-800H853z"/>
              <path id="hoopmask"  d="M0,0v501.1c63.2,25.9,132.4,40.2,205,40.2c298.9,0,541.3-242.3,541.3-541.3H0z"/>
	        </clipPath>
      </defs> 
    </svg>
  </div>

<div className='heroimage'>



<svg baseProfile="tiny" version="1.2" viewBox="0 0 2400 1732" id="circuit-paths-hero-fx">
  <g id="circuit_paths">
    <polyline id="cpath_main" points="0 472.5 740.3 642.1 933.7 618.3 1681.9 796.1 2003.3 754.5 2400 854.2" fill="none" stroke="#20ef20" strokeMiterlimit="10" strokeWidth="2"/>
    <polyline id="cpath_1" points="320.2 219.4 286.6 276 488 500.4 408.5 602.8" fill="none" stroke="#20ef20" strokeMiterlimit="10" strokeWidth="2"/>
    <ellipse id="cpath_1_light" cx="318.4" cy="222.3" rx="12.4" ry="5.9" transform="translate(-12.9 19.8) rotate(-3.5)" fill="#43ff47"/>
    <polyline id="cpath_2" points="350.2 228.3 318.4 277.7 511 493.3 426.2 609.9" fill="none" stroke="#20ef20" strokeMiterlimit="10" strokeWidth="2"/>
    <ellipse id="cpath_2_light" cx="352.9" cy="228.3" rx="12.4" ry="5.9" transform="translate(-13.2 21.9) rotate(-3.5)" fill="#43ff47"/>
    <polyline id="cpath_3" points="601.1 245.9 542.8 329 629.4 433.2 606.4 465 641.8 500.4 615.3 525.1 715.2 636.4 687.7 663.3 724.8 698.2 588.8 844.9 606.4 854.2 510.5 965.3" fill="none" stroke="#2f2" strokeMiterlimit="10" strokeWidth="2"/>
    <ellipse id="cpath_3_light" cx="604.9" cy="243.3" rx="12.4" ry="5.9" transform="translate(-13.7 37.3) rotate(-3.5)" fill="#43ff47"/>
    <ellipse id="light_1" cx="2102" cy="449.1" rx="14" ry="7.5" transform="translate(-47.4 450.8) rotate(-12.1)" fill="#43ff47"/>
    <ellipse id="light_2" cx="2062.3" cy="470" rx="13.8" ry="7.3" transform="translate(-52.7 442.9) rotate(-12.1)" fill="#43ff47"/>
    <ellipse id="light_3" cx="2063.8" cy="496.6" rx="13.8" ry="7.3" transform="translate(-58.2 443.8) rotate(-12.1)" fill="#43ff47"/>
    <ellipse id="light_4" cx="1321.4" cy="468.2" rx="12.4" ry="5.9" transform="translate(-26.1 81.3) rotate(-3.5)" fill="#43ff47"/>
    <ellipse id="light_5" cx="1433.9" cy="545.9" rx="12.4" ry="5.9" transform="translate(-30.6 88.3) rotate(-3.5)" fill="#43ff47"/>
    <ellipse id="light_6" cx="1436.4" cy="411.5" rx="12.4" ry="5.9" transform="translate(-22.4 88.2) rotate(-3.5)" fill="#43ff47"/>
    <ellipse id="light_7" cx="1192.7" cy="536.9" rx="12.4" ry="5.9" transform="translate(-30.5 73.6) rotate(-3.5)" fill="#43ff47"/>
    <ellipse id="light_8" cx="1297.8" cy="538.7" rx="12.4" ry="5.9" transform="translate(-30.4 80) rotate(-3.5)" fill="#43ff47"/>
    <ellipse id="light_9" cx="1104" cy="423.4" rx="12.4" ry="5.9" transform="translate(-23.7 68) rotate(-3.5)" fill="#43ff47"/>
    <ellipse id="light_10" cx="1366.1" cy="417.4" rx="12.4" ry="5.9" transform="translate(-22.9 84) rotate(-3.5)" fill="#43ff47"/>
    <ellipse id="light_11" cx="982.4" cy="344.6" rx="12.4" ry="5.9" transform="translate(-19.2 60.5) rotate(-3.5)" fill="#43ff47"/>
    <ellipse id="light_12" cx="808.8" cy="391.1" rx="12.4" ry="5.9" transform="translate(-22.3 50) rotate(-3.5)" fill="#43ff47"/>
    <ellipse id="light_13" cx="704.1" cy="267.9" rx="12.4" ry="5.9" transform="translate(-15 43.4) rotate(-3.5)" fill="#43ff47"/>
    <ellipse id="light_14" cx="841.9" cy="315.6" rx="12.4" ry="5.9" transform="translate(-17.7 51.9) rotate(-3.5)" fill="#43ff47"/>
    <ellipse id="light_15" cx="488.5" cy="273.3" rx="12.4" ry="5.9" transform="translate(-15.7 30.3) rotate(-3.5)" fill="#43ff47"/>
    <ellipse id="light_16" cx="734.5" cy="102.4" rx="12.4" ry="5.9" transform="translate(-4.9 44.9) rotate(-3.5)" fill="#43ff47"/>
  </g>
</svg>



    <img src={heroimg_portfolio}  />
    </div>
  </div>

  <div className='hero-text'>
    <div className="page-h1">
     <h1>Portfolio</h1>
     <div className="h1-accent"><span></span></div>
    </div>
    <strong>My Design &amp; Development Work</strong>
  </div>
</div>
</div>




  <div className="content">

 

<div className="portfolio-thumb-grid">
  <Getdata />
</div>
  </div>
</main>
  );
};




export default Portfolio;


